module.exports = __webpack_public_path__ + "img/scx.ec7cbafa.png";